<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    label-width="80px"
    style="padding: 30px 20px"
    v-loading="loading"
  >
    <el-form-item label-width="0">
      <el-divider content-position="left" style="margin: 20px 0">
        基础信息
      </el-divider>
    </el-form-item>
    <el-row gutter="10">
      <el-col span="8">
        <el-form-item label="项目名称" prop="projectId">
          <el-select v-model="form.projectId" disabled>
            <el-option
              :label="project.$projectId"
              :value="project.projectId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col span="8">
        <el-form-item label="仪表类型" prop="meterType">
          <el-select
            v-model="form.meterType"
            placeholder="请选择仪表类型"
            @change="meterTypeChange"
            :disabled="dialogTitle === '查看'"
          >
            <el-option
              v-for="item in meterTypeList"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col span="8">
        <el-form-item label="仪表型号" prop="meterModelId">
          <el-select
            v-model="form.meterModelId"
            placeholder="请选择仪表型号"
            @change="meterModelChange"
            :disabled="dialogTitle === '查看'"
          >
            <el-option
              v-for="item in meterModelList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              :disabled="item.status !== 1"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col span="24">
        <el-form-item label="关联仪表" prop="meterIds">
          <avue-input-tree
            ref="tree"
            type="tree"
            check-strictly
            multiple
            v-model="form.meterIds"
            placeholder="请选择内容"
            :props="treeProps"
            :dic="meterTreeData"
            v-if="dialogTitle !== '查看'"
            :tags="false"
            style="width: 100%"
          ></avue-input-tree>

          <el-input
            v-if="dialogTitle === '查看'"
            type="textarea"
            disabled
            :value="form.meterList.map((ele) => ele.meterName).join(' | ')"
          >
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label-width="0">
      <el-divider content-position="left" style="margin: 20px 0">
        报警设置
        <el-button
          type="primary"
          style="margin-left: 30px"
          @click="addItem"
          v-if="dialogTitle !== '查看'"
        >
          新增
        </el-button>
      </el-divider>
    </el-form-item>
    <el-row
      v-for="(item, index) in form.warningDetailList"
      :key="index"
      type="flex"
      align="middle"
    >
      <el-col span="3">
        <el-form-item
          :prop="`warningDetailList[${index}].paramId`"
          :rules="listRules.paramId"
          label-width="0"
          style="margin-bottom: 0"
        >
          <el-select
            v-model="item.paramId"
            placeholder="请选择仪表参数"
            :disabled="dialogTitle === '查看'"
            size="small"
          >
            <el-option
              v-for="item in modelParamsList"
              :key="item.paramId"
              :label="item.paramName"
              :value="item.paramId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col span="1" style="text-align: center">在</el-col>
      <el-col span="3">
        <el-form-item
          :prop="`warningDetailList[${index}].beginNum`"
          :rules="listRules.beginNum"
          label-width="0"
          style="margin-bottom: 0"
          :ref="`beginNum${index}`"
        >
         <avue-input-number
            v-model="item.beginNum"
            :disabled="dialogTitle === '查看'"
            placeholder=""
            size="small"
          ></avue-input-number>
        </el-form-item>
      </el-col>
      <el-col span="1" style="text-align: center">至</el-col>
      <el-col span="3">
        <el-form-item
          :prop="`warningDetailList[${index}].endNum`"
          :rules="listRules.endNum"
          label-width="0"
          style="margin-bottom: 0"
          :ref="`endNum${index}`"
        >
          <avue-input-number
            v-model="item.endNum"
            :disabled="dialogTitle === '查看'"
            placeholder=""
            size="small"
          ></avue-input-number>
        </el-form-item>
      </el-col>
      <el-col span="3" style="text-align: center">之间，通知方式</el-col>
      <el-col span="3">
        <el-form-item
          :prop="`warningDetailList[${index}].notifyWaysArray`"
          :rules="listRules.notifyWaysArray"
          label-width="0"
          style="margin-bottom: 0"
        >
          <el-select
            v-model="item.notifyWaysArray"
            multiple
            placeholder=""
            style="width: 100%"
            :disabled="dialogTitle === '查看'"
            size="small"
          >
            <el-option
              v-for="item in systemNotifyWayList"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
              :disabled="item.dictKey === '3'"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col span="2" style="text-align: center">通知人</el-col>
      <el-col span="4">
        <el-form-item
          :prop="`warningDetailList[${index}].notifyTargetsArray`"
          :rules="listRules.notifyTargetsArray"
          label-width="0"
          style="margin-bottom: 0"
        >
          <UserEditBox
            v-if="form.projectId"
            :projectId="form.projectId"
            :remainUserListInside.sync="item.notifyTargetsArray"
            :allUserList="allUserList"
            :disabled="dialogTitle === '查看'"
          />
        </el-form-item>
      </el-col>
      <el-col span="2" style="margin-left: 20px">
        <el-button
          type="danger"
          size=""
          @click="delItem(index)"
          v-if="dialogTitle !== '查看'"
        >
          删除
        </el-button>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center" style="padding-top: 30px">
      <el-button type="primary" @click="save" v-if="dialogTitle !== '查看'">
        保存
      </el-button>
      <el-button @click="cancel"> 取消 </el-button>
    </el-row>
  </el-form>
</template>
<script>
import {
  getMeterModelList,
  getMeterTree,
  getModelParams,
  warnsetDetail,
} from "@/api/crmedical/energy/alarm-setting";
import { getDictionary } from "@/api/system/dict";

import { getUserListByDepartmentId } from "@/api/crmedical/group/group";

import UserEditBox from "@/views/components/user-edit-box";

export default {
  props: ["project", "meterTypeList", "dialogTitle", "item"],
  components: { UserEditBox },
  data() {
    return {
      form: {
        projectId: "",
        meterType: "",
        meterModelId: "",
        meterIds: [],
        meterList: [],
        warningDetailList: [],
      },
      rules: {
        projectId: [{ required: true }],
        meterType: [{ required: true, message: "请选择仪表类型" }],
        meterModelId: [{ required: true, message: "请选择仪表型号" }],
        meterIds: [
          {
            required: true,
            validator(rule, val, cb) {
              if (val && val.length > 0) {
                cb();
              } else {
                cb(new Error("请选择关联仪表"));
              }
            },
          },
        ],
      },
      loading: false,
      meterModelList: [],
      meterTreeData: [],
      modelParamsList: [],
      systemNotifyWayList: [],
      treeProps: {
        label: "meterName",
        value: "id",
        disabled(item) {
          return item.status !== 1;
        },
      },
      allUserList: [], //这个用于回显，后端给的ids
    };
  },
  computed: {
    listRules() {
      let self = this;
      return {
        paramId: [{ required: true, message: "请选择参数" }],
        beginNum: [
          {
            validator(rule, val, cb) {
              let res = /^warningDetailList\[(\d{1,3})\]\.beginNum/.exec(
                rule.field
              );
              let index = res[1];
              let beginNum = val;
              let endNum = self.form.warningDetailList[index]["endNum"];
              if (!/^[1-9]\d{0,8}(\.\d{1,3})?$|^0(.\d{1,3})?$/.test(val)) {
                cb(new Error("格式错误或者数字过大"));
              } else if (endNum !== "" && beginNum > endNum) {
                cb(new Error("数值应小于后一个值"));
              } else {
                cb();
                if (/^[1-9]\d{0,8}(\.\d{1,3})?$|^0(.\d{1,3})?$/.test(endNum)) {
                  self.$refs["endNum" + index][0].clearValidate();
                }
              }
            },
          },
        ],
        endNum: [
          {
            //联动校验
            validator(rule, val, cb) {
              console.log('val endNum==>',val);
              let res = /^warningDetailList\[(\d{1,3})\]\.endNum/.exec(
                rule.field
              );
              let index = res[1];
              let beginNum = self.form.warningDetailList[index]["beginNum"];
              let endNum = val;
              if (!/^[1-9]\d{0,8}(\.\d{1,3})?$|^0(.\d{1,3})?$/.test(val)) {
                cb(new Error("格式错误或者数字过大"));
              } else if (beginNum !== "" && beginNum > endNum) {
                cb(new Error("数值应大于前一个值"));
              } else {
                cb();
                if (/^[1-9]\d{0,8}(\.\d{1,3})?$|^0(.\d{1,3})?$/.test(beginNum)) {
                  self.$refs["beginNum" + index][0].clearValidate();
                }
              }
            },
          },
        ],
        notifyWaysArray: [
          {
            validator(rule, val, cb) {
              val.length > 0 ? cb() : cb(new Error("请选择通知方式"));
            },
          },
        ],
        notifyTargetsArray: [
          {
            validator(rule, val, cb) {
              val.length > 0 ? cb() : cb(new Error("请选择通知对象"));
            },
          },
        ],
      };
    },
  },
  created() {
    this.form.projectId = this.project.projectId;
    if (this.dialogTitle == "新增") {
      this.addItem();
    } else if (this.dialogTitle == "查看" || this.dialogTitle == "编辑") {
      console.log("查看==>");
      this.item.meterList.forEach((ele) => {
        ele.id = ele.meterId;
        ele.meterId = "";
      });
      this.item.meterIds = this.item.meterList.map((ele) => ele.id);
      this.form = this.item;
      getMeterModelList({ meterType: this.form.meterType })
        .then((res) => {
          this.meterModelList = res.data;
        })
        .catch((err) => {
          console.log("err==>", err);
        });
      this.loadMeterTreeAndModelParams("retainData");
      warnsetDetail({ id: this.item.id }).then(({ data }) => {
        data.meterIds = data.meterList.map((ele) => ele.meterId);
        data.warningDetailList.forEach((ele) => {
          ele.notifyWaysArray = ele.notifyWays.split(",");
          ele.notifyTargetsArray = ele.notifyTargets.split(",").map((ele) => {
            return { id: ele };
          });
        });
        data.meterType += "";
        getUserListByDepartmentId().then((res) => {
          console.log("res getUserListByDepartmentId==>", res);
          this.allUserList = res.data;
          this.form = data;
        });
        // this.form.warningDetailList = data.warningDetailList;
      });
    }
    getDictionary({ code: "system_notify_way" }).then((res) => {
      this.systemNotifyWayList = res.data.data;
    });
  },
  mounted() {},
  methods: {
    save() {
      if (this.form.warningDetailList.length === 0) {
        this.$message.error("请至少添加一条通知方式");
        return;
      }
      this.$refs.form
        .validate()
        .then((res) => {
          this.form.warningDetailList.forEach((ele) => {
            console.log("ele==>", ele);
            ele.notifyTargets = ele.notifyTargetsArray
              .map((element) => element.id)
              .toString();
            ele.notifyWays = ele.notifyWaysArray.toString();
          });
          this.form.meterList = [];
          this.form.meterIds.forEach((element) => {
            this.form.meterList.push({ meterId: element });
          });
          //
          this.$emit("save", this.form, this.dialogTitle);
        })
        .catch((err) => {
          console.log("err==>", err);
        });
    },
    addItem() {
      let item = {
        paramId: "",
        beginNum: "",
        endNum: "",
        notifyWaysArray: [],
        notifyWays: "",
        notifyTargetsArray: [],
        notifyTargets: "",
      };
      this.form.warningDetailList.push(item);
    },
    delItem(index) {
      this.form.warningDetailList.splice(index, 1);
    },
    meterTypeChange(meterType) {
      this.loading = true;
      getMeterModelList({ meterType })
        .then((res) => {
          console.log("res222==>", res);
          this.meterModelList = res.data;
          this.form.meterModelId = "";
          this.form.warningDetailList = [];
          this.addItem();
          this.form.meterIds = [];
          this.form.meterList = [];
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    meterModelChange() {
      this.loadMeterTreeAndModelParams();
    },
    loadMeterTreeAndModelParams(retainData) {
      this.loading = true;
      const params = {
        projectId: this.form.projectId,
        meterModelId: this.form.meterModelId,
        meterType: this.form.meterType,
      };
      const params1 = {
        modelId: this.form.meterModelId,
      };
      Promise.all([getMeterTree(params), getModelParams(params1)])
        .then((res) => {
          this.loading = false;
          this.meterTreeData = res[0].data;
          this.modelParamsList = res[1].data;
          console.log("this.modelParamsList==>", this.modelParamsList);
          if (retainData !== "retainData") {
            this.form.meterIds = [];
            this.form.meterList = [];
            this.form.warningDetailList = [];
            this.addItem();
          }
        })
        .catch((err) => {
          console.log("err==>", err);
          this.loading = false;
        });
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>
